import fetch from '../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords) => {
    return fetch.post('/teacher/listen/analysis/org', keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'file'+ url;
};

export default {
    querySearch,
    onSelect,
    setRefresh,
    redirect,
}